import { Typography } from 'antd';
import { noop } from 'lodash';
import React, { useState } from 'react';
import AppSearchInput from './AppSearchInput';
import { useModalState } from '../hooks/useModalState';
import DocSearchModal from './DocSearch';

export type DocSelectedType = {
  docid?: number;
  docreference?: string;
  doclabel?: string;
};

export type DocSelectProps = {
  onChange?: any;
  value?: DocSelectedType;
  phase?: string;
  onlyDocid?: boolean;
};

const DocSelect = ({
  onChange = noop,
  value,
  phase,
  onlyDocid,
}: DocSelectProps) => {
  const [Params, setParams] = useState<DocSelectedType>({
    docid: value?.docid,
    docreference: value?.docreference,
    doclabel: value?.doclabel,
  });

  const { visible, close, open } = useModalState(false);
  const handleSelect = (item: any) => {
    onlyDocid ? onChange(item.docid) : onChange(item);

    setParams({
      docreference: item?.docreference,
      doclabel: item.doclabel,
      docid: item?.docid,
    });
    close();
  };

  return (
    <>
      <AppSearchInput
        onSearch={open}
        value={
          <Typography.Link>
            {!value?.docid
              ? Params?.docid
                ? `${Params.docreference ?? ''}  -  ${Params.doclabel ?? ''}`
                : 'Select Doc'
              : value?.docid
              ? `${value.docreference ?? ''}  -  ${value.doclabel ?? ''}`
              : 'Select Doc'}
          </Typography.Link>
        }
      />
      <DocSearchModal
        setDoc={handleSelect}
        visible={visible}
        onCancel={close}
      />
    </>
  );
};

export default DocSelect;
